import { motion } from "framer-motion";

// Masked line-by-line reveal. Pass an array of strings as `lines`.
export const RevealLines = ({ lines, className = "", delay = 0 }) => (
  <span className={className}>
    {lines.map((line, i) => (
      <span key={i} className="block overflow-hidden pb-[0.14em] -mb-[0.14em]">
        <motion.span
          className="block"
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ duration: 1, ease: [0.22, 1, 0.36, 1], delay: delay + i * 0.12 }}
        >
          {line}
        </motion.span>
      </span>
    ))}
  </span>
);

export const FadeUp = ({ children, className = "", delay = 0, y = 40 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay }}
  >
    {children}
  </motion.div>
);
